import React from "react";
import { UserModel } from "../../@types/user";
import { RoleModel } from "../../@types/role";

export const MeContext = React.createContext<{
  me: UserModel;
  setMe: (user: UserModel) => void;
  role: RoleModel;
  setRole: (role: RoleModel) => void;
  setCollapsed: (collapsed: boolean) => void;
  collapsed: boolean;
}>({
  me: null,
  role: null,
  collapsed: null,
  setMe: () => {},
  setRole: () => {},
  setCollapsed: () => {},
});
